import { ServerConfig } from "@/config/config";
import { ProductSizeBarcode, ProductSizeStock, SizeTable, SizeTableEntry } from "@/models/base";
import { Axios } from "@/utils/axios";
import { HumanFilter } from "@/utils/human-filter";

const URL = `${ServerConfig.host}/size-table`;
const ENTRY_URL = `${ServerConfig.host}/size-table-entry`;
const SIZE_STOCK_URL = `${ServerConfig.host}/product-size-stock`;
const SIZE_BARCODE_URL = `${ServerConfig.host}/product-size-barcode`;

export class SizeTableServiceClass {

	public async getAll():Promise<SizeTable[]> {
		let result = await Axios.get(URL, {
			params: {
				limit: 1000,
				offset: 0
			}
		});
		return (result.data.data || []).map((t:any) => new SizeTable(t));
	}

	public async getById(id:number):Promise<SizeTable> {
		let result = await Axios.get(`${URL}/${id}`);
		return new SizeTable(result.data);
	}

	public async create(sizeTable:SizeTable):Promise<SizeTable> {
		// wform REST POST/PUT are batch operations: send an array, receive an array.
		let result = await Axios.post(URL, [sizeTable.getJSON()]);
		return new SizeTable(result.data[0]);
	}

	public async update(sizeTable:SizeTable):Promise<SizeTable> {
		let result = await Axios.put(URL, [sizeTable.getJSON()]);
		return new SizeTable(result.data[0]);
	}

	public async delete(id:number):Promise<void> {
		await Axios.delete(`${URL}/${id}`);
	}

	public async createEntry(entry:SizeTableEntry):Promise<SizeTableEntry> {
		let result = await Axios.post(ENTRY_URL, [entry.getJSON()]);
		return new SizeTableEntry(result.data[0]);
	}

	public async updateEntry(entry:SizeTableEntry):Promise<SizeTableEntry> {
		let result = await Axios.put(ENTRY_URL, [entry.getJSON()]);
		return new SizeTableEntry(result.data[0]);
	}

	public async deleteEntry(id:number):Promise<void> {
		await Axios.delete(`${ENTRY_URL}/${id}`);
	}

	public async getEntriesByTableId(sizeTableId:number):Promise<SizeTableEntry[]> {
		let result = await Axios.get(ENTRY_URL, {
			params: {
				limit: 1000,
				offset: 0,
				filters: [
					{
						Field: "this.SizeTableID",
						Operator: "=",
						Values: [sizeTableId + ""]
					}
				] as HumanFilter[]
			}
		});
		return (result.data.data || []).map((e:any) => new SizeTableEntry(e));
	}

	public async getProductSizeStock(productId:number):Promise<ProductSizeStock[]> {
		let result = await Axios.get(`${SIZE_STOCK_URL}/${productId}`);
		return (result.data || []).map((s:any) => new ProductSizeStock(s));
	}

	public async getProductSizeBarcodes(productId:number):Promise<ProductSizeBarcode[]> {
		let result = await Axios.get(`${SIZE_BARCODE_URL}/${productId}`);
		return (result.data || []).map((b:any) => new ProductSizeBarcode(b));
	}

	// Replaces the full set of per-size barcodes for a product. Rows with an empty
	// barcode are dropped server-side.
	public async saveProductSizeBarcodes(productId:number, barcodes:ProductSizeBarcode[]):Promise<ProductSizeBarcode[]> {
		let result = await Axios.put(`${SIZE_BARCODE_URL}/${productId}`, barcodes.map(b => b.getJSON()));
		return (result.data || []).map((b:any) => new ProductSizeBarcode(b));
	}

	public async generateBarcode():Promise<string> {
		let result = await Axios.get(`${SIZE_BARCODE_URL}/generate`);
		return result.data.Barcode;
	}
}

export const SizeTableService = new SizeTableServiceClass();
